var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.userName && !_vm.isDemo)?_c('div',{staticClass:"staging-watermark"},[_vm._v("STAGING")]):_vm._e(),_c('v-main',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }